export default '/build/94ce3734.svg'